// this expression matches the validation on the api, and doesn't cover all accent/diacritic characters
export const LEGAL_NAME = /^[a-zA-Zà-üÀ-Ü '-]*$/;

export const VALID_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const ALPHANUMERIC = /^[a-zA-Z0-9]+$/;

export const NUMERIC = /^\d+$/;

export default {
  LEGAL_NAME,
  VALID_EMAIL,
  ALPHANUMERIC,
  NUMERIC,
};
